<script lang="ts">
  import ServiceOption from './ServiceOption.svelte';

  export let vasEntry;
  export let currency;
</script>

<div class="coating-service-container">
  {#if vasEntry.vasPrices && vasEntry.vasPrices.length > 0}
    {#each vasEntry.vasPrices as vasPrice}
      <ServiceOption
        optionCode={vasPrice?.vasType?.name}
        {currency}
        optionName={vasPrice?.vasType?.label}
        optionPrice={vasPrice?.servicePrice?.formattedValue}
      />
    {/each}
  {/if}
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .coating-service-container {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    :global {
      .mdc-layout-grid {
        padding: 0;
      }
      .mdc-layout-grid__inner {
        align-items: center;
      }
    }
  }
</style>
